module.exports = __webpack_public_path__ + "static/media/apple-alt.09068328.svg";